module.exports = __webpack_public_path__ + "img/certificate-virtual_pet.f45a9c63.png";